import * as http from "./base";

const prefix = "/campaigns-";

export async function fetchCampaignsList({
  page,
  sort,
  search,
  page_size,
  queryString
}) {
  const qs = http.prepareQueryString({
    page,
    sort,
    search,
    page_size,
    queryString
  });

  return await http.get(`${prefix}list/?${qs}`);
}

export async function fetchCampaignById(id) {
  return await http.get(`${prefix}retrieve/${id}`);
}

export async function createCampaign(data) {
  return await http.post(`${prefix}create`, data, { newErrorFormat: true });
}

export async function editCampaign(campaignId, data) {
  return await http.patch(`${prefix}update/${campaignId}`, data);
}

export async function deleteCampaign(id) {
  return await http.del(`${prefix}delete/${id}`);
}

export async function sendCampaign(id) {
  return await http.post(`/send-campaign/`, { campaign_id: id });
}

export async function fetchPreviewById(id) {
  return await http.get(`${prefix}send-summary?campaign_id=${id}`);
}
